import React from "react";
import { Box, Skeleton, Grid, Card } from "@mui/material";

const MainSkeleton = () => {
  return (
    <Box sx={{ p: 2 }}>
      {/* Header Section Skeleton */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="circular" width={40} height={40} />
      </Box>

      {/* Welcome Message Skeleton */}
      <Skeleton variant="text" width="60%" height={30} sx={{ mb: 3 }} />

      {/* Summary Section Skeleton */}
      <Skeleton variant="text" width="40%" height={25} sx={{ mb: 2 }} />
      <Card sx={{ borderRadius: "20px", mb: 6, p: 2 }}>
        <Skeleton variant="rectangular" height={60} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={40} />
      </Card>

      {/* Enhance Your Experience Section Skeleton */}
      <Skeleton variant="text" width="50%" height={25} sx={{ mb: 1 }} />
      <Grid container spacing={2}>
        {Array.from(new Array(4)).map((_, index) => (
          <Grid item xs={6} key={index}>
            <Skeleton
              variant="rectangular"
              height={100}
              sx={{ borderRadius: "20px" }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MainSkeleton;
